import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.pinhacorada.com';

const routeMeta: Record<string, { title: string; description: string; noindex?: boolean }> = {
  '/': {
    title: 'Pinhacorada - Silvicultura Preventiva e Manutenção de Espaços Verdes | Mortágua',
    description: 'Pinhacorada: Empresa especializada em silvicultura preventiva, manutenção de espaços verdes e obras públicas em Mortágua. 12 anos de experiência.',
  },
  '/carreiras': {
    title: 'Carreiras - Pinhacorada | Oportunidades de Emprego em Silvicultura',
    description: 'Junte-se à equipa Pinhacorada. Vagas em silvicultura preventiva, manutenção de espaços verdes e arboricultura em Mortágua.',
  },
  '/politica-privacidade': {
    title: 'Política de Privacidade - Pinhacorada',
    description: 'Política de privacidade da Pinhacorada.',
    noindex: true,
  },
  '/politica-cookies': {
    title: 'Política de Cookies - Pinhacorada',
    description: 'Política de cookies da Pinhacorada.',
    noindex: true,
  },
  '/termos-servico': {
    title: 'Termos de Serviço - Pinhacorada',
    description: 'Termos e condições de utilização do website da Pinhacorada.',
    noindex: true,
  },
};

export default function DynamicHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = routeMeta[pathname] || routeMeta['/'];
    const canonicalUrl = pathname === '/' ? `${BASE_URL}/` : `${BASE_URL}${pathname}`;

    // Título
    document.title = meta.title;

    // Canonical
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalLink) {
      canonicalLink.href = canonicalUrl;
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = canonicalUrl;
      document.head.appendChild(canonicalLink);
    }

    // Meta description
    const descMeta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (descMeta) {
      descMeta.content = meta.description;
    }

    // Open Graph
    const ogUrl = document.querySelector('meta[property="og:url"]') as HTMLMetaElement | null;
    if (ogUrl) ogUrl.content = canonicalUrl;

    const ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement | null;
    if (ogTitle) ogTitle.content = meta.title;

    const ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement | null;
    if (ogDesc) ogDesc.content = meta.description;

    // Twitter
    const twUrl = document.querySelector('meta[name="twitter:url"]') as HTMLMetaElement | null;
    if (twUrl) twUrl.content = canonicalUrl;

    const twTitle = document.querySelector('meta[name="twitter:title"]') as HTMLMetaElement | null;
    if (twTitle) twTitle.content = meta.title;

    const twDesc = document.querySelector('meta[name="twitter:description"]') as HTMLMetaElement | null;
    if (twDesc) twDesc.content = meta.description;

    // Robots
    const robotsMeta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (robotsMeta) {
      robotsMeta.content = meta.noindex
        ? 'noindex, nofollow'
        : 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1';
    }

    const googlebotMeta = document.querySelector('meta[name="googlebot"]') as HTMLMetaElement | null;
    if (googlebotMeta) {
      googlebotMeta.content = meta.noindex ? 'noindex, nofollow' : 'index, follow';
    }
  }, [pathname]);

  return null;
}
